import { render, staticRenderFns } from "./serviceproviderscomponent.vue?vue&type=template&id=5a45d6ca&"
import script from "./serviceproviderscomponent.vue?vue&type=script&lang=ts&"
export * from "./serviceproviderscomponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports